import type { ReactNode } from "react";
import type { Perimetre, PerimetreWithoutTerritoire } from "models";
import { Box, Skeleton, Typography } from "@mui/material";
import CompetenceChip from "components/CompetenceChip";

interface PerimetreBoxProps {
  perimetre: Perimetre | PerimetreWithoutTerritoire;
  isLoading?: boolean;
  noWrap?: boolean;
}

export function PerimetreBox({
  perimetre,
  isLoading = false,
  noWrap = false,
}: Readonly<PerimetreBoxProps>): ReactNode {
  if (isLoading) {
    return <Skeleton />;
  }

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <Typography noWrap={noWrap}>
        <CompetenceChip competence={perimetre.competence} sx={{ mr: 1 }} />
        {perimetre.code} - {perimetre.libelle}
      </Typography>
    </Box>
  );
}
